import React from 'react';

export function getCurrentUTCDate() {
    const now = new Date();
    return new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    ));
  }

export function formatToDayMonth(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  
  const ordinal = 
    (day === 1 || day === 21 || day === 31) ? 'st' :
    (day === 2 || day === 22) ? 'nd' :
    (day === 3 || day === 23) ? 'rd' : 'th';
  
  return `${day}${ordinal} ${month}`;
}

export const formatCompactNumber = (num, decimals = 2) => {
  if (typeof num !== 'number') return '0';
  
  const formatter = Intl.NumberFormat('en', {
    notation: 'compact',
    maximumFractionDigits: decimals
  });
  
  return formatter.format(num);
};

export const BubbleInput = ({ length, value, onChange }) => {
  const inputRef = React.useRef(null);
  
  const handleChange = (e) => {
    const newValue = e.target.value.slice(0, length);
    onChange(newValue);
  };
  
  const handleClick = () => {
    inputRef.current.focus();
  };
  
  return (
    <div className="bubble-input-container" onClick={handleClick}>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={handleChange}
        maxLength={length}
        autoComplete="off"
      /> 
      <div className="bubble-input">
        {Array.from({ length }).map((_, index) => (
          <div 
            key={index}
            className={`bubble-char ${index < value.length ? 'filled' : ''}`}
          >
            {value[index] || ''}
          </div>
        ))}
      </div>
    </div>
  );
};